import { components } from "@/api-schema";
import { commonColumns } from "./_constants/common-columns";

export type JobFunctionTableType = components["schemas"]["JobFunction"];

export const jobFunctionTableDefaultColumns = {
  columnName: commonColumns.columnName<JobFunctionTableType>(),
  columnTechnicalId: commonColumns.columnTechnicalId<JobFunctionTableType>(),
  columnDeletedAt: commonColumns.columnDeletedAt<JobFunctionTableType>(),
  columnUuid: commonColumns.columnUuid<JobFunctionTableType>(),
  columnV1Id: commonColumns.columnV1Id<JobFunctionTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<JobFunctionTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<JobFunctionTableType>(),
};
